import {
    SET_RANKED_VIEW_TAB,
    SET_RANKED_LIST,
    SET_DISABLE_RANKED_VIEW_TAB,
    SET_SOURCE_ARTICLE,
    SET_RANKED_MINI_LIST
} from '../../actions';

const initialState = {
    tab: 0,
    rankedList: null,
    disable: true,
    source: null,
    rankedMiniList: null
}

function rankedArticleReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_RANKED_VIEW_TAB:
            newState.tab = action.tab;
            newState.rankedList = state.rankedList;
            newState.disable = state.disable;
            newState.source = state.source;
            newState.rankedMiniList = state.rankedMiniList;
            return newState;
        
        case SET_RANKED_LIST:
            newState.tab = state.tab;
            newState.rankedList = action.rankedList;
            newState.disable = state.disable;
            newState.source = state.source;
            newState.rankedMiniList = state.rankedMiniList;
            return newState;
        
        case SET_DISABLE_RANKED_VIEW_TAB:
            newState.tab = state.tab;
            newState.rankedList = state.rankedList;
            newState.disable = action.disable;
            newState.source = state.source;
            newState.rankedMiniList = state.rankedMiniList;
            return newState;

        case SET_SOURCE_ARTICLE:
            newState.tab = state.tab;
            newState.rankedList = state.rankedList;
            newState.disable =  state.disable;
            newState.source = action.source;
            newState.rankedMiniList = state.rankedMiniList;
            return newState;

        case SET_RANKED_MINI_LIST:
            newState.tab = state.tab;
            newState.rankedList = state.rankedList;
            newState.disable =  state.disable;
            newState.source = state.source;
            newState.rankedMiniList = action.rankedMiniList;
            return newState;
        
        default:
            return state;

    }
 
}

export default rankedArticleReducer;
